/**
 * @description: 影片管理
 * @author: hwx
 */
<template>
	<div class="movie-manage-wrap">
		<div class="movie-list" v-show="showList">
			<div class="row row-margin">
				<button type="button" class="btn btn-flat btn-small btn-orange" @click="addMovie">新增影片</button>
			</div>
			<div class="row row-margin">
				<label class="col-md-1 list-label-2">时间:</label>
				<div class="col-md-3 movie-time">
					<div ref="time">
						<input type="text" class="form-control laydate-icon" v-model="start_time"> -
						<input type="text" class="form-control laydate-icon" v-model="end_time">
					</div>
				</div>
				<label class="col-md-1 list-label-2">门店:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="movie_shop"></select>
				</div>
				<label class="col-md-1 list-label-4">影片类型:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="movie_type"></select>
				</div>
				<label class="col-md-1 list-label-4">影片名称:</label>
				<div class="col-md-2">
					<input type="text" class="form-control" v-model="movie_name" placeholder="请输入影片名称">
				</div>
			</div>
			<div class="row">
				<p class="col-md-3">注：带硬盘版本不可用</p>
				<div class="pull-right">
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="movieQuery">查询</button>
					<a href="https://vodonline.oss-cn-beijing.aliyuncs.com/Download/moviesImportTemplate.xls" class="btn btn-flat btn-small btn-orange">模板下载</a>
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="addXlsFun">导入</button>
					<input type="file" @change="uploadMovieXls($event)" id="movieXlsFile" ref="movieXlsFile">
					<button type="button" class="btn btn-flat btn-middle btn-orange" @click="openMovieType" v-show="movie_shop_id != ''">影片类型管理</button>
					<button type="button" class="btn btn-flat btn-middle btn-gray" v-show="movie_shop_id == ''">影片类型管理</button>
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="clearMovie">清空</button>
				</div>
			</div>
			<div class="table-responsive">
				<table class="table table-bordered table-hover" data-pagination="true" ref="movie_list"></table>
			</div>
		</div>
		<!-- 影片类型管理 -->
		<div class="movie-type-edit" ref="movie_type_edit">
			<div class="table-responsive">
				<table class="table table-bordered table-hover" data-pagination="true" ref="movie_type_list"></table>
			</div>
			<p>注：触摸屏电影类型只支持设置6种，分类排序序号越小则触摸屏展现越靠前。</p>
		</div>
		<!-- 新增、修改 -->
		<div class="movie-edit" v-show="showEdit">
			<div class="page-tit">{{edit_tit}}</div>
			<div class="edit-shop">
				<h3>门店基本信息</h3>
				<div class="row">
					<label class="col-md-1 ctr-label-left">门店:</label>
					<div class="col-md-5 ct-col">
						<select class="form-control" ref="edit_shop"></select>
					</div>
				</div>
			</div>
			<div class="edit-movie">
				<h3>影片基本信息</h3>
				<div class="row">
					<label class="col-md-1 ctr-label-left">影片类型:</label>
					<div class="col-md-5 ct-col">
						<select class="form-control" ref="edit_type"></select>
					</div>
				</div>
				<div class="row">
					<label class="col-md-1 ctr-label-left">影片名称:</label>
					<div class="col-md-5">
						<input class="form-control" placeholder="请输入电影名称" v-model="edit_name">
					</div>
				</div>
				<div class="row">
					<label class="col-md-1 ctr-label-left">影片主演:</label>
					<div class="col-md-5">
						<input class="form-control" placeholder="请输入电影主演名称" v-model="edit_actor">
					</div>
				</div>
				<div class="row">
					<label class="col-md-1 ctr-label-left">影片文件名属性:</label>
					<div class="col-md-5">
						<input class="form-control" placeholder="请输入对应的文件命名属性（.mkv等格式）" v-model="edit_suffix">
					</div>
				</div>
			</div>
			<div class="edit-img">
				<h3>影片封面图片</h3>
				<div class="row">
					<div class="col-md-6">
						<img class="edit-img-cover" :src="edit_cover" @click="coverFun">
						<input type="file" id="coverFile" ref="cover_file" @change="uploadCover($event)">
						<p>图片在触摸屏端显示。【图片规范：260*365，大小不超过2M，格式为PNG】</p>
					</div>
				</div>
			</div>
			<div class="row">
				<button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backList">返回</button>
				<button type="button" class="btn btn-flat btn-middle btn-orange sub-margin" @click="editMovie">确定</button>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		// name: 'movie_manage',
		data() {
			return {
				showList: true,
				showEdit: false,
				modify: '1',
				start_time: '',
				end_time: '',
				end_time: '',
				movie_shop_id: '',
				movie_name: '',
				movie_type_data: [],
				movie_list_total: '',
				edit_tit: '新增影片',
				edit_id: '',
				edit_name: '',
				edit_actor: '',
				edit_suffix: '',
				edit_cover: require('../../assets/images/uld_btn.png'),
			}
		},
		watch: {
			
		},
		mounted: function() {
			let _this = this;
			
			// 日期
			let myDate = new Date();
			_this.IntstartTime = new Date();
			_this.IntendTime = new Date(myDate.getTime() + 1 * 24 * 3600 * 1000);
			let timStar = new Date(this.IntstartTime),
				year = timStar.getFullYear(),
				month = (timStar.getMonth() + 1) < 10 ? '0' + (timStar.getMonth() + 1) : (timStar.getMonth() + 1),
				day = timStar.getDate() < 10 ? '0' + timStar.getDate() : timStar.getDate();
			let timEnd = new Date(this.IntendTime),
				yearend = timEnd.getFullYear(),
				monthend = (timEnd.getMonth() + 1) < 10 ? '0' + (timEnd.getMonth() + 1) : (timEnd.getMonth() + 1),
				dayend = timEnd.getDate() < 10 ? '0' + timEnd.getDate() : timEnd.getDate();
			_this.start_time = year + '-' + month + '-' + day;
			_this.end_time = yearend + '-' + monthend + '-' + dayend;
			_this.initDate();
			_this.getShopData();
		},
		methods: {
			// 初始化日期
			initDate: function() {
				let _this = this;

				$(_this.$refs.time).daterangepicker({
					buttonClasses: ['btn btn-default'],
					applyClass: 'btn-small btn-orange',
					cancelClass: 'btn-small btn-gray',
					startDate: _this.IntstartTime,
					endDate: _this.IntendTime,
				}, function(start, end, label) {
					_this.start_time = start.format('YYYY-MM-DD');
					_this.end_time = end.format('YYYY-MM-DD');
				});
			},
			// 门店
			getShopData: function() {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							
						}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							let arr = [];
							$.each(data.response.result, function(k, v) {
								arr.push({ id: v.id, text: v.name });
							});
							$(_this.$refs.movie_shop).select2({
								data: arr,
								minimumResultsForSearch: -1,
								language: "zh-CN",
								width: '100%'
							}).on("select2:select", function(e) {
								if(e.params.data.text == "全部") {
									_this.movie_shop_id = '';
									$(_this.$refs.movie_type).val('').trigger('change');
									$(_this.$refs.movie_type).prop("disabled", true);
									return;
								}
								_this.movie_shop_id = e.params.data.id;
								$(_this.$refs.movie_type).prop("disabled", false);
								_this.getMovieType();
							});
							_this.movie_shop_id = data.response.result[1].id;
							$(_this.$refs.movie_shop).val(_this.movie_shop_id).trigger('change');
							// 获取影片类型
							$(_this.$refs.movie_type).prop("disabled", false);
							_this.getMovieType();
							_this.initTable();

							arr.shift();
							$(_this.$refs.edit_shop).select2({
								data: arr,
								minimumResultsForSearch: -1,
								language: "zh-CN",
								width: '100%'
							}).on("select2:select", function(e) {
								_this.getEidtMovieType(e.params.data.id);
							});
							_this.getEidtMovieType($(_this.$refs.edit_shop).val());
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data["response"]["error_msg"]);
						}
					},
					error: function(err) {
						layer.msg('网络错误');
					}
				});
			},
			// 获取影片类型
			getMovieType: function() {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": _this.movie_shop_id
						}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "Setting/getMovieTypeList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							_this.movie_type_data = data.response.result;
							let arr = [{ id: ' ', text: '全部' }];
							$.each(data.response.result, function(k, v) {
								arr.push({ id: v.id, text: v.name });
							});
							$(_this.$refs.movie_type).html('');
							$(_this.$refs.movie_type).select2({
								data: arr,
								minimumResultsForSearch: -1,
								language: "zh-CN",
								width: '100%'
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data["response"]["error_msg"]);
						}
					},
					error: function(err) {
						layer.msg('网络错误');
					}
				});
			},
			// 编辑页影片类型
			getEidtMovieType: function(shop_id) {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": shop_id
						}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "Setting/getMovieTypeList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							let arr = [];
							$.each(data.response.result, function(k, v) {
								arr.push({ id: v.id, text: v.name });
							});
							$(_this.$refs.edit_type).html('');
							$(_this.$refs.edit_type).select2({
								data: arr,
								minimumResultsForSearch: -1,
								language: "zh-CN",
								width: '100%'
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data["response"]["error_msg"]);
						}
					},
					error: function(err) {
						layer.msg('网络错误');
					}
				});
			},
			// 初始化列表
			initTable: function() {
				let _this = this;
				$(_this.$refs.movie_list).bootstrapTable('destroy');
				$(_this.$refs.movie_list).bootstrapTable({
					pageNumber: 1,
					pageSize: 15,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getMovieList(params);
					},
					sidePagination: "server",
					columns: [{
						field: "shop_name",
						title: "门店",
						width: "10%",
						valign: 'middle'
					}, {
						field: "type_name",
						title: "类型",
						width: "10%",
						valign: 'middle'
					}, {
						field: "name",
						title: "影片名称",
						width: "10%",
						valign: 'middle'
					}, {
						field: "img",
						title: "影片封面图",
						width: "10%",
						valign: 'middle',
						formatter: function(value, row, index) {
							return '<img class="img-size" src="'+ value +'" />'
						}
					}, {
						field: "actors",
						title: "主演",
						width: "10%",
						valign: 'middle'
					}, {
						field: "create_time",
						title: "添加时间",
						width: "10%",
						valign: 'middle'
					}, {
						field: "file_name",
						title: "文件名",
						width: "10%",
						valign: 'middle'
					}, {
						title: "操作",
						width: "15%",
						valign: 'middle',
						events: {
							'click .edit': function(e, value, row, index) {
								_this.modify = 2;
								_this.edit_id = row.id;
								$(_this.$refs.edit_shop).val(row.shop_id).trigger('change');
								_this.getEidtMovieType(row.shop_id);
								$(_this.$refs.edit_type).val(row.type_id).trigger('change');
								_this.edit_name = row.name;
								_this.edit_actor = row.actors;
								_this.edit_suffix = row.file_name;
								if(row.img != '') {
									_this.edit_cover = row.img;
									$('.edit-img-cover').attr('suc', '1');
								} else {
									_this.edit_cover = require('../../assets/images/uld_btn.png');
									$('.edit-img-cover').removeAttr('suc');
								}
								_this.showList = false;
								_this.showEdit = true;
							},
							'click .del': function(e, value, row, index) {
								layer.confirm('删除后不可恢复，确定删除吗？', {
									btn: ['确定', '取消']
								}, function() {
									_this.delMovie(row.id);
								});
							}
						},
						formatter: function(value, row, index) {
							return '<span class="text-blue edit">修改</span>&nbsp;&nbsp;&nbsp;<span class="text-blue del">删除</span>'
						}
					}]
				});
			},
			getMovieList: function(params) {
				let _this = this,
					pageNumber = 1;
				if(params != "" && params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"start_time": _this.start_time,
							"end_time": _this.end_time,
							"shop_id": $.trim($(_this.$refs.movie_shop).val()),
							"type_id": $.trim($(_this.$refs.movie_type).val()),
							"name": _this.movie_name
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "Setting/getMoviesList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							if(pageNumber == '1') {
								_this.movie_list_total = data.response.result.count;
							}
							params.success({
								total: _this.movie_list_total,
								rows: data.response.result.data
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 查询
			movieQuery: function() {
				this.initTable();
			},
			// 点击上传xls文件
			addXlsFun: function() {
				this.$refs.movieXlsFile.click();
			},
			// 上传
			uploadMovieXls: function(e) {
				let _this = this;

				let formData = new FormData();
				formData.append("moviesFile", $("#movieXlsFile")[0].files[0]);
				// 清除file
				let obj = document.getElementById('movieXlsFile');
				obj.value = '';

				$.ajax({
					type: "post",
					dataType: "json",
					processData: false,
					contentType: false,
					url: Vue.ctUrl + "Setting/importMovies",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: formData,
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.msg('导入成功');
							$(_this.$refs.movie_list).bootstrapTable('refresh');
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 打开影片类型
			openMovieType: function() {
				let _this = this;
				_this.initMovieType();
				layer.open({
					type: 1,
					title: '影片类型管理',
					skin: 'layui-layer-rim', // 加上边框
					area: ['660', ''], // 宽高
					content: $(_this.$refs.movie_type_edit)
				});
			},
			// 影片类型表格
			initMovieType: function() {
				let _this = this;
				$(_this.$refs.movie_type_list).bootstrapTable('destroy');
				$(_this.$refs.movie_type_list).bootstrapTable({
					columns: [{
						field: "listorder",
						title: "排序",
						width: "25%",
						valign: 'middle',
						events: {
							'blur .movie-type-inp': function (e, value, row, index) {
								_this.movie_type_data[index] = {
									"id": row.id,
									"listorder": $.trim($(this).val()),
									"name": _this.movie_type_data[index].name
								};
								_this.editMovieType(_this.movie_type_data[index]);
							}
						},
						formatter: function(value, row, index) {
							return '<input type="text" placeholder="请输入序号" class="movie-type-inp" value="'+ value +'" />'
						}
					}, {
						field: "name",
						title: "影片类型",
						width: "25%",
						valign: 'middle',
						events: {
							'blur .movie-type-inp': function (e, value, row, index) {
								_this.movie_type_data[index] = {
									"id": row.id,
									"listorder": _this.movie_type_data[index].listorder,
									"name": $.trim($(this).val())
								};
								_this.editMovieType(_this.movie_type_data[index]);
							}
						},
						formatter: function(value, row, index) {
							return '<input type="text" placeholder="请输入名称" class="movie-type-inp" value="'+ value +'" />'
						}
					}],
					data: _this.movie_type_data
				});
			},
			// 修改影片类型
			editMovieType: function(param) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": param
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "Setting/editMovieType",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.msg(data.response.error_msg);
							_this.getMovieType();
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 点击新增
			addMovie: function() {
				let _this = this;
				_this.modify = '1';
				_this.edit_tit = '新增影片';
				$(_this.$refs.edit_shop).val('').trigger('change');
				$(_this.$refs.edit_type).val('').trigger('change');
				_this.edit_name = '';
				_this.edit_actor = '';
				_this.edit_suffix = '';
				_this.edit_cover = require('../../assets/images/uld_btn.png');
				$('.edit-img-cover').removeAttr('suc');
				_this.showList = false;
				_this.showEdit = true;
			},
			// 点击上传封面
			coverFun: function() {
				this.$refs.cover_file.click();
			},
			// 上传封面
			uploadCover: function(e) {
				let _this = this;
				let layIndex = layer.load(2, {
					shade: [0.1, '#ececec']
				});
				let file = e.target.files[0];
				// 清除file
				let obj = document.getElementById('coverFile');
				obj.value = '';
				obj.outerHTML = obj.outerHTML;
				// 压缩图片
				var reader = new FileReader(),
					img = new Image();
				var canvas = document.createElement('canvas');
				var context = canvas.getContext('2d');
				if(typeof(file) == 'undefined') {
					layer.msg('图片上传失败');
					layer.close(layIndex);
					return false;
				}
				reader.readAsDataURL(file);
				reader.onload = function(e) {
					img.src = e.target.result;
				};
				img.onload = function () {
					// 图片原始尺寸
					var originWidth = this.width;
					var originHeight = this.height;
					// 最大尺寸限制
					var maxWidth = 260, maxHeight = 365;
					// 目标尺寸
					var targetWidth = originWidth, targetHeight = originHeight;
					// 图片尺寸超过限制
					if(originWidth > maxWidth || originHeight > maxHeight) {
						if(originWidth / originHeight > maxWidth / maxHeight) {
							// 更宽，按照宽度限定尺寸
							targetWidth = maxWidth;
							targetHeight = Math.round(maxWidth * (originHeight / originWidth));
						} else {
							targetHeight = maxHeight;
							targetWidth = Math.round(maxHeight * (originWidth / originHeight));
						}
					}
					// canvas对图片进行缩放
					canvas.width = targetWidth;
					canvas.height = targetHeight;
					// 清除画布
					context.clearRect(0, 0, targetWidth, targetHeight);
					// 图片压缩
					context.drawImage(img, 0, 0, targetWidth, targetHeight);
					// canvas转为blob并上传
					var dataurl = canvas.toDataURL('image/png');
					var blob = dataURLtoBlob(dataurl);
					// 创建forme
					var form = new FormData();
					form.append('img', blob, "image.png");
					form.append("upload_path", "ktv_test");
					// 上传
					$.ajax({
						type: "post",
						dataType: "json",
						processData: false,
						contentType: false,
						url: Vue.ctUrl + "Upload/api_uploadPic",
						crossDomain: true,
						xhrFields: {
							withCredentials: true
						},
						data: form,
						success: function(data) {
							if(data.response.result_code == "true") {
								_this.edit_cover = data.response.resault.img_url;
								$('.edit-img-cover').attr('suc', '1');
							} else {
								Vue.timeoutfun(data.response.result_status, _this);
								layer.msg("图片上传失败");
							}
							layer.close(layIndex);
						},
						error: function(err) {
							layer.msg("网络原因");
							layer.close(layIndex);
						}
					});
				}
			},
			// 返回列表
			backList: function() {
				this.showList = true;
				this.showEdit = false;
			},
			// 新增、修改
			editMovie: function() {
				let _this = this,
					img = '';

				if($('.edit-img-cover').attr('suc') == '1') {
					img = _this.edit_cover;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"shop_id": $(_this.$refs.edit_shop).val(),
							"type_id": $(_this.$refs.edit_type).val(),
							"name": _this.edit_name,
							"actors": _this.edit_actor,
							"file_name": _this.edit_suffix,
							"img": img
						}
					},
					"comment": ""
				};
				if(_this.modify == '2') {
					datas["request"]["param"]["id"] = _this.edit_id;
				}
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "Setting/editMovie",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.msg(data.response.error_msg);
							$(_this.$refs.movie_list).bootstrapTable("refresh");
							_this.showList = true;
							_this.showEdit = false;
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 删除
			delMovie: function(id) {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "Setting/delMovie",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.msg(data.response.error_msg);
							$(_this.$refs.movie_list).bootstrapTable("refresh");
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 清空
			clearMovie: function(id) {
				let _this = this;
				layer.confirm('清空后不可恢复，确定清空吗？', {
					btn: ['确定', '取消']
				}, function() {
					let datas = {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
								"start_time": _this.start_time,
								"end_time": _this.end_time,
								"shop_id": $.trim($(_this.$refs.movie_shop).val()),
								"type_id": $.trim($(_this.$refs.movie_type).val()),
								"name": _this.movie_name
							}
						},
						"comment": ""
					};
					let datas2 = JSON.stringify(datas);
					$.ajax({
						type: "post",
						dataType: "json",
						url: Vue.ctUrl + "Setting/emptyMovies",
						crossDomain: true,
						xhrFields: {
							withCredentials: true
						},
						data: {
							json: datas2
						},
						success: function(data) {
							if(data.response.result_code == "true") {
								layer.msg(data.response.error_msg);
								$(_this.$refs.movie_list).bootstrapTable("refresh");
							} else {
								Vue.timeoutfun(data.response.result_status, _this);
								layer.msg(data.response.error_msg);
							}
						},
						error: function(err) {
							layer.msg("出错啦");
						}
					});
				});
			},
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	.movie-manage-wrap {
		.movie-list {
			.movie-time {
				width: 300px;
				input {
					display: inline-block;
					width: 125px;
				}
			}
			p {
				color: #ff2e2e;
			}
			.pull-right {
				button {
					margin: 0 0 0 30px;
				}
				>a {
					margin: 0 0 0 30px;
				}
				input {
					display: none;
				}
			}
			.img-size {
				display: block;
				width: 50px;
				height: 50px;
				border: none;
				margin: 0 auto;
			}
		}
		.movie-type-edit {
			display: none;
			width: 80%;
			margin: 20px auto;
			.movie-type-inp {
				height: 30px;
				padding: 0 8px;
				border: 1px solid #D6D6D6;
			}
		}
		.movie-edit {
			h3 {
				margin: 0 0 30px;
				font-size: 18px;
			}
			.edit-shop {
				padding: 30px;
				background: #f5f5f5;
			}
			.edit-movie {
				padding: 30px;
				margin: 30px 0;
				background: #f5f5f5;
			}
			.edit-img {
				padding: 30px;
				margin: 0 0 30px;
				background: #f5f5f5;
				div {
					padding: 0 0 0 2em;
					img {
						display: block;
						width: 200px;
						height: 200px;
						cursor: pointer;
					}
					input {
						display: none;
					}
					p {
						margin: 20px 0 0;
					}
				}
			}
		}
	}
</style>